import { defineComponent as M, ref as y, computed as l, onMounted as O, onUnmounted as Y, createElementBlock as f, createCommentVNode as r, openBlock as s, createBlock as b, createElementVNode as u, unref as h, Fragment as q, renderList as G, normalizeClass as g, toDisplayString as k, resolveDynamicComponent as $, normalizeStyle as H } from "vue";
import { RevButtonIcon as w } from "@ds/components/ButtonIcon";
import { usePositionedStyle as J } from "../../composables/usePositionedStyle.js";
import K from "../../icons/generated/IconArrowLeft.vue2.js";
import Q from "../../icons/generated/IconCross.vue2.js";
import { isEmpty as X } from "../../utils/isEmpty.js";
import { createObserver as Z } from "../../utils/resizeObserver.js";
import { tw as o } from "../../utils/tailwind.js";
const ee = {
  key: 1,
  class: "flex flex-1 list-none flex-nowrap"
}, te = ["aria-label"], ae = { class: "line-clamp-2 flex-1" }, le = { class: "line-clamp-2 flex flex-1 items-center justify-center" }, se = {
  "aria-hidden": "",
  class: "border-t-static-default-low absolute bottom-0 h-2 w-full border-t-2"
}, ne = ["max", "value"], me = /* @__PURE__ */ M({
  name: "RevStepper",
  __name: "Stepper",
  props: {
    activeStep: {},
    hasBack: { type: Boolean },
    alternativeTextBack: {},
    hasClose: { type: Boolean },
    alternativeTextClose: {},
    steps: {},
    alternativeTextCompleted: {},
    alternativeTextCurrent: {}
  },
  emits: ["back", "close"],
  setup(T, { emit: B }) {
    const t = T, S = B, p = y(null), v = y(null);
    let i;
    const a = l(
      () => t.steps.findIndex(({ name: e }) => e === t.activeStep)
    ), L = l(
      () => `Step ${+a.value + 1} of ${t.steps.length}`
    ), _ = l(() => !X(t.steps)), I = l(() => {
      const e = a;
      return `${+e.value + 1}/${t.steps.length} ${t.steps[+e.value].label}`;
    }), R = l(() => +a.value + 1), x = l(() => v.value ? v.value < 768 ? !1 : v.value < 1200 ? t.steps.length <= 3 : t.steps.length <= 5 : !0);
    O(() => {
      _.value && (i = Z({
        $el: p.value,
        autoUnobserve: !1,
        callback: (c) => {
          const n = c[0];
          v.value = n.contentRect.width;
        }
      }), i && p.value !== null && i.observe(p.value));
    }), Y(() => {
      i == null || i.disconnect();
    });
    const A = () => {
      S("back");
    }, D = () => {
      S("close");
    }, E = (e) => e.name === t.activeStep, N = (e) => e > a.value, U = (e) => e < +a.value ? t.alternativeTextCompleted : e === +a.value ? t.alternativeTextCurrent : "", V = (e, c) => [
      o`flex h-56 flex-1 items-center border-0 bg-transparent px-40 text-center`,
      E(e) ? o`body-1-bold` : o`body-1`,
      N(c) ? o`text-static-default-low` : o`text-static-default-hi`
    ], C = (e, c) => `${c + 1}. ${e.label}`, F = {
      left: "0",
      width: "0px"
    }, m = y(), P = l(() => {
      var e;
      return (e = m == null ? void 0 : m.value) == null ? void 0 : e[a.value];
    }), { style: W } = J({
      callback: (e) => ({
        left: "0",
        width: `${e.offsetLeft + e.offsetWidth}px`
      }),
      defaultStyle: F,
      elementRef: P
    }), j = l(() => x.value ? W.value : {
      left: 0,
      width: `${100 * (1 + a.value) / t.steps.length}%`
    }), z = l(() => [
      o`text-static-default-hi body-1 flex h-56 w-full items-center text-center`,
      (t.hasBack || t.hasClose) && o`px-40`
    ]);
    return (e, c) => _.value ? (s(), f("div", {
      key: 0,
      ref_key: "wrapper",
      ref: p,
      class: "relative flex items-center"
    }, [
      e.hasBack ? (s(), b(h(w), {
        key: 0,
        "alternative-text": e.alternativeTextBack,
        class: "absolute inset-y-0 left-0 mt-8",
        icon: h(K),
        variant: "secondary",
        onClick: A
      }, null, 8, ["alternative-text", "icon"])) : r("", !0),
      x.value ? (s(), f("ol", ee, [
        (s(!0), f(q, null, G(e.steps, (n, d) => (s(), f("li", {
          key: n.name,
          ref_for: !0,
          ref_key: "stepsRef",
          ref: m,
          "aria-label": `${U(d)} ${C(
            n,
            d
          )}`,
          class: g(V(n, d)),
          "data-test": "step.name"
        }, [
          u("span", ae, k(C(n, d)), 1),
          n.suffix ? (s(), b($(n.suffix), { key: 0 })) : r("", !0)
        ], 10, te))), 128))
      ])) : r("", !0),
      x.value ? r("", !0) : (s(), f("div", {
        key: 2,
        class: g(z.value)
      }, [
        u("span", le, [
          u("span", null, k(I.value), 1),
          e.steps[a.value].suffix ? (s(), b($(e.steps[a.value].suffix), { key: 0 })) : r("", !0)
        ])
      ], 2)),
      e.hasClose ? (s(), b(h(w), {
        key: 3,
        "alternative-text": e.alternativeTextClose,
        class: "absolute inset-y-0 right-0 mt-8",
        icon: h(Q),
        variant: "secondary",
        onClick: D
      }, null, 8, ["alternative-text", "icon"])) : r("", !0),
      u("div", se, [
        u("div", {
          class: "border-t-static-default-hi absolute -top-2 border-t-2 ease-in-out motion-safe:transition-all motion-safe:duration-200",
          style: H(j.value)
        }, null, 4)
      ]),
      u("progress", {
        class: "sr-only",
        max: e.steps.length,
        value: R.value
      }, k(L.value), 9, ne)
    ], 512)) : r("", !0);
  }
});
export {
  me as default
};
